// eslint-disable-next-line import/no-extraneous-dependencies
import classNames from 'classnames';
import { SUBTYPES } from 'envs';
import { arrayToDict } from '../../utils';
import {
  customAcronym,
  customColor,
  getSite,
  isAntena3
} from '../../constants';
import useMatchParties from './useMatchParties';

// Given an array of ids, retrieve the sum of previous seats
const getPreviousSeats = (ids, parties) =>
  ids.reduce((result, id) => (parties[id] ? parties[id].seats : 0) + result, 0);

export default function useFormatParties({
  currentData,
  pastData,
  excludes = []
}) {
  const matchParties = useMatchParties() || [];

  const idsNoCount = isAntena3(getSite()) ? excludes : [];

  if (
    !matchParties ||
    !currentData ||
    !currentData.partiesResult ||
    !pastData ||
    !pastData.partiesResult
  ) {
    return null;
  }

  const partyFormats = arrayToDict(matchParties, 'currentId');
  const dictPastData = arrayToDict(pastData.partiesResult);
  return currentData.partiesResult.map(party => {
    const partyFormat = partyFormats[party.id];
    // TDOO Ñapita para comparar
    // Almeria CONAND compara con podemos

    if (partyFormat) {
      if (party.id === 5774 && currentData.id === '04013') {
        partyFormat.previousIds = 8014;
      }
      // Barcelona Cs compara con Barcelona  Percami ciutadans
      if (party.id === 27 && currentData.id === '08019') {
        partyFormat.previousIds = 1456;
      }
      if (party.id === 5782 && currentData.id === '08019') {
        partyFormat.previousIds = 8015;
      }
      // Barcelona TRIAS PER BARCELONA compara con JUNTS PER CATALUNYA
      if (party.id === 1277 && currentData.id === '08019') {
        partyFormat.previousIds = 1464;
      }

      // en ceuta se compara Ceuta Ya con caballas
      if (party.id === 5467 && currentData.id === '51001') {
        partyFormat.previousIds = 6849;
      }

      // Cordoba CONAND compara con podemos
      if (party.id === 5774 && currentData.id === '14021') {
        partyFormat.previousIds = 8014;
      }

      // Gijon  Convocatoria por gijon de iu
      if (party.id === 6046 && currentData.id === '33024') {
        partyFormat.previousIds = 1415;
      }

      // Hospitalet de llobregat
      if (party.id === 5782 && currentData.id === '08101') {
        partyFormat.previousIds = 8015;
      }
      // logroño
      if (party.id === 3252 && currentData.id === '26089') {
        partyFormat.previousIds = 8014;
      }
      if (party.id === 3239 && currentData.id === '26089') {
        partyFormat.previousIds = 3906;
      }

      // Sumar compara con Podemos y Más País
      // if (party.id === 10) {
      //   partyFormat.previousIds = [43, 28, 78, 48, 46, 74]; // 78 podemos nacional 48 mes compromis en valencia  // cataluña el 28 es podemos  // coruña   74 podemos
      // }

      // Izquierdas por la independencia compara con ERC y EH Bildu, sólo a nivel nacional
      if (party.id === 95 && currentData.id === 'C108' && SUBTYPES.CONGRESS) {
        partyFormat.previousIds = [29, 31];
      }
    }
    const previousSeat =
      idsNoCount.some(id => id === party.id) || !partyFormat
        ? 0
        : getPreviousSeats(
            Array.isArray(partyFormat?.previousIds)
              ? partyFormat?.previousIds
              : [partyFormat.previousIds],
            dictPastData
          );

    const difference =
      matchParties.length <= 0 ? 0 : party.seats - previousSeat;
    // const difference = party.seats - previousSeat;
    const symbolClassName = classNames([
      'partyEscanos',
      {
        less: partyFormat?.previousIds && difference < 0,
        more: partyFormat?.previousIds && difference > 0,
        equal: partyFormat?.previousIds && difference === 0,
        nodata: !partyFormat?.previousIds
      }
    ]);
    const partyAcronym = customAcronym(party, getSite());
    const partyColor = customColor(party, getSite());
    // if (!partyAcronym) {
    // }

    return {
      ...partyFormat,
      ...party,
      partyAcronym,
      partyColor,
      difference,
      nodata: !partyFormat?.previousIds,
      symbolClassName,
      previousSeat
    };
  });
}
